import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function(element) {
    gsap.from(element.querySelectorAll(".grass-6, .grass-2, .grass-3"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
            // toggleActions: "play none play none",
        },
        y: 80,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.1
    });
    gsap.from(element.querySelectorAll(".grass-4, .grass-5"), {
        scrollTrigger: {
            trigger: element,
            start: "top center",
            // toggleActions: "play none play none",
        },
        x: (i) => i === 2 || i === 1 ? 60 : -60,
        y: (i) => i === 2 ? 20 : -30,
        scale: 0.6,
        opacity: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.1
    });
    // gsap.from(element.querySelector(".experience__block"), {
    //     scrollTrigger: {
    //         trigger: element,
    //         start: "top center",
    //         // toggleActions: "play none play none",
    //     },
    //     xPercent: 100,
    //     duration: 2,
    //     ease: "power4.out",
    // });
};